import { render, staticRenderFns } from "./BannerHome.vue?vue&type=template&id=d289c3a0&scoped=true&"
import script from "./BannerHome.vue?vue&type=script&lang=js&"
export * from "./BannerHome.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=d289c3a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d289c3a0",
  null
  
)

export default component.exports